// gift-bar.js — Lee el carrito de Shopify y actualiza todas las barras
const GIFT_GOAL = 500; // mismo valor que en el snippet
const GIFT_NAME = "Set Hidratante de Viaje";

async function updateGiftBars() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const total = cart.total_price / 100; // Shopify devuelve centavos
    const remaining = Math.max(GIFT_GOAL - total, 0);
    const pct = Math.min((total / GIFT_GOAL) * 100, 100);
    const unlocked = total >= GIFT_GOAL;

    document.querySelectorAll('.gift-bar').forEach(bar => {
      const id = bar.id.replace('gift-bar-', '');

      bar.classList.toggle('unlocked', unlocked);

      const icon = document.getElementById(`gift-icon-${id}`);
      const label = document.getElementById(`gift-label-${id}`);
      const fill = document.getElementById(`gift-fill-${id}`);
      const sub = document.getElementById(`gift-sub-${id}`);

      if (icon) icon.textContent = unlocked ? '🎁' : '🔒';

      if (label) {
        label.innerHTML = unlocked
          ? '¡Regalo desbloqueado! Se agrega a tu pedido'
          : `Te faltan <strong style="color:#B45309">$${remaining.toFixed(0)}</strong> para tu regalo gratis`;
      }

      if (fill) fill.style.width = `${pct}%`;

      if (sub) {
        sub.textContent = unlocked
          ? `${GIFT_NAME} agregado · Gratis`
          : `${GIFT_NAME} · Valor $290`;
      }
    });
  } catch (e) {
    console.warn('Gift bar: no se pudo leer el carrito', e);
  }
}

// Ejecutar al cargar
document.addEventListener('DOMContentLoaded', updateGiftBars);

// Escuchar cuando se agrega algo al carrito (evento estándar de Shopify)
document.addEventListener('cart:updated', updateGiftBars);

// Para carritos que usan fetch propio, exponer la función globalmente
window.updateGiftBars = updateGiftBars;